// extracted by mini-css-extract-plugin
module.exports = {"main":"IntroSection_main__h51X6","content":"IntroSection_content__657pt"};